function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { isObject } from "../../is/index";
import { curry, dig } from "../../fn/index";
import { defaultSpacingTheme } from "./spacing";
export var backgroundColor = curry(function(backgroundColorContextString, theme) {
    return {
        backgroundColor: dig(backgroundColorContextString, theme.backgroundColor)
    };
});
export var borderWidth = function(borderWidthKey, theme) {
    return {
        borderWidth: "".concat(theme.size.border[borderWidthKey], "px")
    };
};
export var borderColor = curry(function(borderColorContextString, theme) {
    return {
        borderColor: dig(borderColorContextString, theme.borderColor)
    };
});
export var borderTopColor = curry(function(borderColorContextString, theme) {
    return {
        borderTopColor: dig(borderColorContextString, theme.borderColor)
    };
});
export var borderLeftColor = curry(function(borderColorContextString, theme) {
    return {
        borderLeftColor: dig(borderColorContextString, theme.borderColor)
    };
});
export var borderRightColor = curry(function(borderColorContextString, theme) {
    return {
        borderRightColor: dig(borderColorContextString, theme.borderColor)
    };
});
export var borderBottomColor = curry(function(borderColorContextString, theme) {
    return {
        borderBottomColor: dig(borderColorContextString, theme.borderColor)
    };
});
export var borderRadius = curry(function(radiusSize, theme) {
    return {
        borderRadius: theme.size.border.radius[radiusSize]
    };
});
export var boxShadow = curry(function(variant, theme) {
    return {
        boxShadow: "".concat(theme.depth.boxShadow[variant].xOffset, " ").concat(theme.depth.boxShadow[variant].yOffset, " ").concat(theme.depth.boxShadow[variant].blurRadius, " ").concat(theme.depth.boxShadow[variant].spreadRadius, " ").concat(theme.depth.boxShadow[variant].color)
    };
});
export var boxShadowFocus = function(borderColorContextString, theme, inset) {
    var colorOptions = borderColorContextString !== 'borderColor' ? dig(borderColorContextString, theme.borderColor) : theme.borderColor;
    return {
        boxShadow: "".concat(inset ? 'inset ' : '', "0 0 0 ").concat(theme.size.border.focus, "px ").concat(colorOptions === null || colorOptions === void 0 ? void 0 : colorOptions.focus)
    };
};
export var fill = curry(function(colorContextString, theme) {
    return {
        fill: dig(colorContextString, theme.font.color)
    };
});
export var fontFamily = curry(function(family, theme) {
    return {
        fontFamily: theme.font[family].family
    };
});
export var fontSize = curry(function(size, theme) {
    return {
        fontSize: isObject(size) ? theme.font[size.context].size[size.size] : theme.font.base.size[size]
    };
});
export var fontWeight = curry(function(weight, theme) {
    return {
        fontWeight: isObject(weight) ? theme.font[weight.context].weight[weight.weight] : theme.font.base.weight[weight]
    };
});
export var color = curry(function(colorContextString, theme) {
    return {
        color: dig(colorContextString, theme.font.color)
    };
});
export var lineHeight = curry(function(lHeight, theme) {
    return {
        lineHeight: theme.font.lineHeight[lHeight]
    };
});
export var typography = curry(function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, fFamily = ref.fontFamily, fSize = ref.fontSize, fWeight = ref.fontWeight, lHeight = ref.lineHeight, colorContextString = ref.color, theme = arguments.length > 1 ? arguments[1] : void 0;
    return _objectSpread({}, fFamily && {
        fontFamily: theme.font[fFamily].family
    }, fWeight && fontWeight(fWeight, theme), fSize && fontSize(fSize, theme), lHeight && lineHeight(lHeight, theme), colorContextString && color(colorContextString, theme));
});
var spacingAttributeFor = function(attribute) {
    return function() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 7;
        return _defineProperty({}, attribute, defaultSpacingTheme[size]);
    };
};
export var padding = spacingAttributeFor('padding');
export var paddingBottom = spacingAttributeFor('paddingBottom');
export var paddingLeft = spacingAttributeFor('paddingLeft');
export var paddingRight = spacingAttributeFor('paddingRight');
export var paddingTop = spacingAttributeFor('paddingTop');
export var margin = spacingAttributeFor('margin');
export var marginBottom = spacingAttributeFor('marginBottom');
export var marginLeft = spacingAttributeFor('marginLeft');
export var marginRight = spacingAttributeFor('marginRight');
export var marginTop = spacingAttributeFor('marginTop');
export var height = spacingAttributeFor('height');
export var minHeight = spacingAttributeFor('minHeight');
export var maxHeight = spacingAttributeFor('maxHeight');
export var width = spacingAttributeFor('width');
export var minWidth = spacingAttributeFor('minWidth');
export var maxWidth = spacingAttributeFor('maxWidth');
export var top = spacingAttributeFor('top');
export var bottom = spacingAttributeFor('bottom');
export var right = spacingAttributeFor('right');
export var left = spacingAttributeFor('left');
